import {
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import { ReceiveAgentCommissionMutationUpdateInput } from './model';

export function usePurchaseReceiveAgentCommission(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    ReceiveAgentCommissionMutationUpdateInput
  >,
): UseMutationResult<
  ApiResult<any>,
  ApiError,
  ReceiveAgentCommissionMutationUpdateInput
> {
  return useMutation<
    ApiResult<any>,
    ApiError,
    ReceiveAgentCommissionMutationUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `purchases/receive-agent-commission/${body.id}`,
      method: 'PUT',
      body: body.body,
    });
  }, options);
}

export function useCancelPurchaseReceiveAgentCommission(
  id: string,
  options?: UseMutationOptions<ApiResult<any>, ApiError>,
): UseMutationResult<ApiResult<any>, ApiError> {
  return useMutation<ApiResult<any>, ApiError>(async function () {
    return await MutationFetchFunction({
      url: `purchases/cancel-receive-agent-commission/${id}`,
      method: 'PUT',
    });
  }, options);
}
